import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

// Attach customer token to customer-specific calls via request header
api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("rieave.admin.token");
  const customerToken = localStorage.getItem("rieave.customer.token");
  const url = config.url || "";
  // Admin endpoints
  if (url.startsWith("/admin") || url.startsWith("/auth/admin/me")) {
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  } else {
    // Default to customer token for customer-scoped calls
    if (customerToken) config.headers.Authorization = `Bearer ${customerToken}`;
  }
  return config;
});

export const formatINR = (n) => {
  const num = Number(n || 0);
  return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};
